module.exports = __webpack_public_path__ + "static/media/summary-report.96e1e213.svg";